import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="comment-form"
export default class extends Controller {
  static targets = ["input", "submit"];

  connect() {
    this.toggleButton();
  }

  toggleButton() {
    const isNotEmpty = this.inputTarget.value.trim().length > 0;

    if (isNotEmpty) {
      // Active state - Green theme
      this.submitTarget.classList.remove("bg-gray-200", "text-gray-400");
      this.submitTarget.classList.add("bg-green-600", "text-white");
      this.submitTarget.removeAttribute("disabled");
    } else {
      // Inactive state - Grayed out
      this.submitTarget.classList.add("bg-gray-200", "text-gray-400");
      this.submitTarget.classList.remove("bg-green-600", "text-white");
      this.submitTarget.setAttribute("disabled", "disabled");
    }
  }
}
